import { render, staticRenderFns } from "./ApfQuestions.vue?vue&type=template&id=8946d80e"
import script from "./ApfQuestions.vue?vue&type=script&lang=js"
export * from "./ApfQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports